import PageHeader from "../components/PageHeader";
import ServiceList from "../components/Service-List";
import ServiceForm from "../components/Service-Form";

const Service = () => {
    return (
        <>
            <PageHeader pagetitle="Service" breadcrumbMenu="Home" breadcrumbMenuActive="Service" image="/images/service-banner.png" />
            <ServiceList />
            <ServiceForm />
        </>
    )
}

export default Service;